import { Terms } from "../types";

export const content: Terms.Content = {
  id: -1,
  content: "",
};
